// Shopping Cart
export const SET_ITEM_COUNT = 'SET_ITEM_COUNT';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const RESET_SHOPPING_CART = 'RESET_SHOPPING_CART';

// Credit Card
export const SET_TYPING_STATUS = 'SET_TYPING_STATUS';
export const SET_CARD_INFO = 'SET_CARD_INFO';
export const EMPTY_CREDIT_CARD = 'EMPTY_CREDIT_CARD';